module.exports = __webpack_public_path__ + "static/media/icon-library.f934b567.svg";